<mat-form-field class="w-full h-12 min-h-12">
    <mat-label>{{ field.templateOptions.label }}</mat-label>
    <mat-select [formControl]="selectCtrl" #singleSelect [disabled]="isDisabled()">
        <mat-option>
            <ngx-mat-select-search [placeholderLabel]="field.templateOptions.placeholder" [formControl]="filterCtrl">
                <div ngxMatSelectNoEntriesFound class="flex justify-between">
                    <span> Nenhum registro corresponde à pesquisa. </span>
                    <mat-progress-spinner *ngIf="loading$ | async" mode="indeterminate" [diameter]="32"
                        color="primary"></mat-progress-spinner>
                </div>
            </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of (filteredDataSource$ | async); trackBy: trackByFn" [value]="item">
            {{ item.user.fullName }}
        </mat-option>
    </mat-select>
</mat-form-field>